// Hides [data-readmore-content] entirely and animates it open/closed from a
// [data-readmore-toggle] button. The collapsed height comes from the element's
// own max-h-0 class, so nothing shows before the JS runs.
export default function readMore(root = document) {
    root.querySelectorAll('[data-readmore]').forEach(wrapper => {
        const content = wrapper.querySelector('[data-readmore-content]');
        const toggle = wrapper.querySelector('[data-readmore-toggle]');

        if (!content || !toggle || toggle.dataset.readmoreReady) {
            return;
        }

        const label = toggle.querySelector('[data-readmore-label]') || toggle;
        const moreText = toggle.dataset.readmoreMore || 'Show disclaimer';
        const lessText = toggle.dataset.readmoreLess || 'Hide disclaimer';

        toggle.dataset.readmoreReady = 'true';
        toggle.setAttribute('aria-expanded', 'false');

        let expanded = false;

        const afterTransition = () => {
            // Let an open panel size itself, so its content can reflow freely.
            content.style.maxHeight = expanded ? 'none' : '';
        };

        toggle.addEventListener('click', () => {
            expanded = !expanded;

            toggle.classList.toggle('is-open', expanded);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            label.textContent = expanded ? lessText : moreText;

            if (expanded) {
                content.style.maxHeight = `${content.scrollHeight}px`;
            } else {
                content.style.maxHeight = `${content.scrollHeight}px`;
                void content.offsetHeight; // flush the start value before animating
                content.style.maxHeight = '';
            }

            content.addEventListener('transitionend', afterTransition, { once: true });
        });
    });
}
